import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import Fa from 'react-fontawesome';
import ReactResizeDetector from 'react-resize-detector';
import {
  Button, Modal, PanelGroup,
  Panel, Collapse,
  Nav, NavItem, Tab,
} from 'react-bootstrap';
import { find } from 'lodash';
import DateTimeDisplay from '../../../../components/date-time-display';
import MoneyDisplay from '../../../../components/money-display';
import { getColorFromKey } from '../../../../util/helpers';
import EvidenceBox from './EvidenceBox';
import { fetchInsights, fetchAccountInsights } from '../../../Dashboard/DashboardActions';
import { getIsMobile, getViewableDimensions } from '../../../App/AppReducer';


import styles from './styles.css';

class StrengthModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: null,
      showInsights: {}, // indexed by insight_id
      insights: {},
      headerHeight: 0,
      footerHeight: 0,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.showInsight = this.showInsight.bind(this);
    this.handleSelectAutoLoad = this.handleSelectAutoLoad.bind(this);
    this.hanldeHeaderResize = this.hanldeHeaderResize.bind(this);
    this.hanldeFooterResize = this.hanldeFooterResize.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show && !this.props.show && nextProps.stregth && !this.state.activeKey) {
      const firstItem = nextProps.stregth.items[0];
      if (firstItem) {
        if (this.props.isMobile) {
          this.handleSelect(firstItem.id);
        } else {
          this.handleSelectAutoLoad(firstItem.id);
        }
      }
    }
  }

  hanldeHeaderResize(w, headerHeight) {
    this.setState({ headerHeight });
  }
  hanldeFooterResize(w, footerHeight) {
    this.setState({ footerHeight });
  }


  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  handleSelectAutoLoad(activeKey) {
    this.setState({ activeKey }, () => {
      const { stregth, isAccount } = this.props;
      const s = find(stregth ? stregth.items : [], { id: activeKey });
      if (s) {
        const id = isAccount ? s.object.account_id : s.object.opportunity_id;
        this.showInsight(activeKey, id, s.feedback.insight_id, true);
      }
    });
  }

  handleClose() {
    this.props.onClose();
    this.setState({ activeKey: null });
  }

  showInsight(id, objectId, insightId, force = false) {
    const { showInsights } = this.state;
    const { isAccount } = this.props;
    const showing = showInsights[id] === true;
    const newShowing = force === true ? force : !showing;
    this.setState({ showInsights: { ...showInsights, [id]: newShowing } }, () => {
      if (!this.state.insights[id]) {
        const action = isAccount ? fetchAccountInsights : fetchInsights;
        this.props.dispatch(action(objectId, insightId, true))
          .then(
            ({ insight }) => {
              this.setState({ insights: { ...this.state.insights, [id]: insight } });
            },
            () => {},
          );
      }
    });
  }

  renderTitle() {
    const { stregth } = this.props;
    if (!stregth) {
      return null;
    }
    const { label, type, client } = stregth;
    const cls = type === 'Strength' ? 'text-success' : 'text-danger';
    return (
      <Modal.Header closeButton>
        <Modal.Title>
          {label}: <span className={cls}>{type}</span> for {client}
        </Modal.Title>
        <ReactResizeDetector handleHeight onResize={this.hanldeHeaderResize} />
      </Modal.Header>
    );
  }

  renderHTML(raw) {
    return <span dangerouslySetInnerHTML={{ __html: raw }} />;
  }

  renderEvidences(id, item) {
    const { showInsights } = this.state;
    const { isMobile, isAccount } = this.props;
    const { feedback, object } = item;
    const showing = showInsights[id] === true;
    const objectId = isAccount ? object.account_id : object.opportunity_id;
    return (
      <div>
        <Collapse in={showing}>
          <div className="well">
            <EvidenceBox insight={this.state.insights[id]} />
          </div>
        </Collapse>
        {isMobile &&
          <div>
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                this.showInsight(id, objectId, feedback.insight_id);
              }}
            >
              {!showing && <span>show linked evidences <Fa name="caret-down" /></span>}
              {showing && <span>hide linked evidences <Fa name="caret-up" /></span>}
            </a>
          </div>
        }
      </div>
    );
  }

  renderItemHeading(item, withLink = false) {
    const { isAccount } = this.props;
    if (isAccount) {
      return (
        <span>
          {withLink && <a href={item.feedback.overview_url} target="_blank">{item.object.name} <Fa name="external-link" /></a>}
          {!withLink && <span>{item.object.name}</span>}
          <br />
          <small>TTM: <MoneyDisplay value={item.object.ttm} abbreviated /></small>
        </span>
      );
    }
    const color = getColorFromKey(item.object.stage);
    return (
      <span>
        <span className={styles.stage} style={{ color }}>
          <MoneyDisplay value={item.object.amount} abbreviated />
          {' '}
          {item.object.stage}
        </span>
        {' '}
        <DateTimeDisplay value={item.object.close_date} format="MMM YYYY" />
        {' at '}
        {withLink && <a href={item.feedback.overview_url} target="_blank">{item.object.name} <Fa name="external-link" /></a>}
        {!withLink && <span>{item.object.name}</span>}
      </span>
    );
  }
  renderMobileBody() {
    const { stregth } = this.props;
    const { activeKey } = this.state;
    if (!stregth) {
      return null;
    }
    return (
      <Modal.Body>
        <PanelGroup
          accordion
          id="strength-accordion"
          activeKey={activeKey}
          onSelect={this.handleSelect}
        >
          {stregth.items.map((item) => {
            const { id } = item;
            const isActive = id === activeKey;
            return (
              <Panel
                eventKey={id}
                key={id}
                className={styles.panel}
              >
                <Panel.Heading>
                  <Panel.Title>
                    <Panel.Toggle componentClass="div" className={styles.panelToggle}>
                      <table>
                        <tbody>
                          <tr>
                            <td width="99%">
                              <strong>
                                {this.renderItemHeading(item)}
                              </strong>
                            </td>
                            <td valign="top" style={{ paddingLeft: 10 }}><Fa name={isActive ? 'caret-up' : 'caret-down'} /></td>
                          </tr>
                        </tbody>
                      </table>
                    </Panel.Toggle>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <div>
                    <strong>{item.feedback.impact_text}</strong>: {this.renderHTML(item.feedback.insight_statement)}
                  </div>
                  {this.renderEvidences(id, item)}
                </Panel.Body>
              </Panel>
            );
          })}
        </PanelGroup>
      </Modal.Body>
    );
  }

  renderBody() {
    const { stregth, viewableDimensions, isAccount } = this.props;
    const {
      activeKey, insights, footerHeight, headerHeight,
    } = this.state;
    if (!stregth) {
      return null;
    }
    const hasMultiple = stregth.items.length > 1;
    const remainingHeight = Math.max(0, viewableDimensions.height - footerHeight - headerHeight - 60); // margin: 30
    return (
      <div>
        <div style={{ maxHeight: remainingHeight, overflowY: 'auto', overflowX: 'hidden' }}>
          <Tab.Container
            id="strength-tabs"
            defaultActiveKey={activeKey}
            onSelect={this.handleSelectAutoLoad}
            className={styles.tabs}
          >
            <div className="row">
              {hasMultiple &&
                <div className="col-sm-4">
                  <Nav bsStyle="pills" stacked>
                    {stregth.items.map((item) => {
                      const { id } = item;
                      return (
                        <NavItem key={id} eventKey={id}>
                          {this.renderItemHeading(item)}
                        </NavItem>
                      );
                    })}
                  </Nav>
                </div>
              }
              <div className={hasMultiple ? 'col-sm-8' : 'col-sm-12'}>
                <Tab.Content animation>
                  {stregth.items.map((item) => {
                    const { id } = item;
                    let isWon = item.object.stage === 'Won';
                    if (isAccount) {
                      isWon = item.feedback.experience_condition === 'Positive';
                    }
                    return (
                      <Tab.Pane key={id} eventKey={id}>
                        {!hasMultiple &&
                          <div>
                            <h4>{this.renderItemHeading(item)}</h4>
                          </div>
                        }
                        <div className={`alert ${isWon ? 'alert-success' : 'alert-danger'}`}>
                          <strong>{item.feedback.impact_text}</strong>: {this.renderHTML(item.feedback.insight_statement)}
                        </div>
                        <hr />
                        <div className="well">
                          <EvidenceBox insight={insights[id]} />
                        </div>
                      </Tab.Pane>
                    );
                  })}
                </Tab.Content>
              </div>
            </div>
          </Tab.Container>
        </div>
      </div>
    );
  }

  render() {
    const { show, isMobile } = this.props;
    return (
      <Modal
        show={show}
        onHide={this.handleClose}
        onExited={this.props.onExited}
        bsSize="lg"
      >
        {this.renderTitle()}
        {isMobile && this.renderMobileBody()}
        {!isMobile && this.renderBody()}
        <Modal.Footer>
          <Button bsStyle="link" onClick={this.handleClose}>
            Close
          </Button>
          <ReactResizeDetector handleHeight onResize={this.hanldeFooterResize} />
        </Modal.Footer>
      </Modal>
    );
  }
}

StrengthModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  onExited: PropTypes.func,
  show: PropTypes.bool,
  isMobile: PropTypes.bool,
  isAccount: PropTypes.bool,
  viewableDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  stregth: PropTypes.shape({
    label: PropTypes.string,
    type: PropTypes.string,
    client: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      feedback: PropTypes.shape({
        id: PropTypes.string,
        insight_statement: PropTypes.string,
        insight_id: PropTypes.string,
        impact_text: PropTypes.string,
        overview_url: PropTypes.string,
        initiative_id: PropTypes.string,
      }),
      object: PropTypes.shape({
        name: PropTypes.string,
        amount: PropTypes.number,
        stage: PropTypes.string,
        opportunity_id: PropTypes.string,
        account_id: PropTypes.string,
        close_date: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.instanceOf(moment),
        ]),
      }),
    })),
  }),
};
StrengthModal.defaultProps = {
  stregth: null,
  onClose: () => {},
  onExited: () => {},
  show: false,
  isMobile: false,
  isAccount: false,
  viewableDimensions: {
    width: 0,
    height: 0,
  },
};
function mapStateToProps(state) {
  return {
    isMobile: getIsMobile(state),
    viewableDimensions: getViewableDimensions(state),
  };
}


export default connect(mapStateToProps)(StrengthModal);
